@if(loader){
<app-loader></app-loader>
}
<p-card [header]="isEditMode ? 'Update Purchase Return' : 'Create Purchase Return'">
    <div>
        <form [formGroup]="purchaseOrderForm">
            <div class="field col-12 flex justify-content-between align-items-center">
                <div class="flex justify-content-start">
                    <div>
                        @if(!isEditMode){
                        <p-button label="Save" icon="pi pi-save" size="small" (click)="performAction('Save')"
                            class="mr-2"></p-button>
                        <!-- <p-button label="Reset" (click)="resetForm()" class="p-button-outlined ml-2 "
                            icon="pi pi-replay" severity="info" size="small"></p-button> -->
                        }
                        @if (purchaseOrderForm.controls.PurchaseOrder_Status.value === 'Draft' && isEditMode) {
                        <p-button label="Update" severity="info" (click)="updatePO(purchaseOrderForm.value)"
                            icon="pi pi-arrow-circle-up" size="small" class="mr-2"></p-button>
                        }
                        @if (purchaseOrderForm.controls.PurchaseOrder_Status.value === 'Open' && isEditMode) {
                        <p-button label="Close" severity="warning" (click)="performAction('Close')" icon="pi pi-lock"
                            size="small" class="mr-2"></p-button>
                        }
                        @if(purchaseOrderForm.controls.PurchaseOrder_Status.value === 'Draft' && isEditMode){
                        <p-button label="Approve" icon="pi pi-check-circle" severity="success" size="small"
                            (click)="performAction('Approve')" class="mr-2"></p-button>
                        }
                    </div>
                    <p-button label="Linked Files" icon="pi pi-paperclip" size="small" (click)="openLinkedFiles()"
                    class="p-button-sm ml-2"></p-button>
                    <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small" class="p-button-sm ml-2"
                        (click)="Cancel()"></p-button>
                </div>

                <div>
                    <label class="block label-required" style="font-weight: bold;">Required Field</label>
                </div>
            </div>

            <div class="grid mt-4">
                <div class="col">

                    <div class="field text-left">
                        <label for="vendorName" class="label-required display">Vendor</label>
                        <span class="p-fluid">
                            <div style="display: flex;">
                                <p-autoComplete formControlName="vendorName" [forceSelection]="true"
                                    [readonly]="products.length > 0 || isEditMode" (onSelect)="setVendor($event)"
                                    [suggestions]="VendorList" Style="width: 250px;"
                                    (completeMethod)="autosearchVendor($event)" field="vendorName"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.vendorCode.errors }"
                                    (keydown.enter)="focusNextInput($event)">
                                    <ng-template let-item pTemplate="item">
                                        <span>{{item.vendorCode}} - {{item.vendorName}}</span>
                                    </ng-template>
                                </p-autoComplete>
                                <button type="button" [disabled]="products.length > 0" pButton pRipple
                                    (click)="getVendor()" icon="pi pi-search" styleClass="p-button-warn"
                                    [disabled]="isEditMode" style="margin-left: 10px;"></button>
                            </div>
                        </span>
                        <input type="hidden" formControlName="vendorCode" />
                    </div>

                    <div class="field text-left">
                        <label for="address">Vendor Address</label>
                        <div class="p-inputgroup p-lookup">
                            <input pInputText placeholder="Vendor Address" id="address" readonly formControlName="add"
                                styleClass="w-full" (keydown.enter)="focusNextInput($event)" />
                        </div>
                    </div>

                    <div class="field text-left">
                        <label for="Warehouse" class="label-required display">{{unitLabel}}</label>
                        <p-autoComplete [dropdown]="(products.length > 0)? false : true" [forceSelection]="true"
                            [readonly]="products.length > 0" formControlName="warehouseName" styleClass="w-full"
                            [suggestions]="filtewarehouse" (completeMethod)="filteWarehouse($event)"
                            (onSelect)="SelectedWarehouse($event)" field="warehouseName" placeholder="Search"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.warehouseName.errors }"
                            (keydown.enter)="focusNextInput($event)">
                            <ng-template let-item pTemplate="item">
                                <span>{{item.warehouseCode}} - {{item.warehouseName}}</span>
                            </ng-template>
                        </p-autoComplete>
                        <!-- Hidden warehouse ID field for validation -->
                        <input type="hidden" formControlName="warehouseId" />
                    </div>

                    <div class="field text-left">
                        <label for="address">{{unitLabel}} Address</label>
                        <div class="p-inputgroup p-lookup">
                            <input pInputText placeholder="{{unitLabel}} Address" id="address" readonly 
                                formControlName="warehouseAddress" styleClass="w-full" />
                        </div>
                    </div>
                </div>
                <div class="col">

                    <div class="field text-left">
                        <label for="receiptNumber" class="label-required display">Receipt Order Number</label>
                        <span class="p-fluid">
                            <div style="display: flex;">
                                <p-autoComplete formControlName="receiptNumber" [readonly]="products.length > 0"
                                    [suggestions]="ReceiptList" (completeMethod)="autosearchReceipts($event)" [forceSelection]="true" 
                                    (onSelect)="setReceiptNumber($event)" field="poReceiptNumber" Style="width: 285px;"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.receiptNumber.errors }"
                                    (keydown.enter)="focusNextInput($event)">
                                    <ng-template let-item pTemplate="item">
                                        <span>{{item.poReceiptNumber}}</span>
                                    </ng-template>
                                </p-autoComplete>
                                <button type="button" [disabled]="products.length > 0" pButton pRipple
                                    (click)="openPOListLookup()" icon="pi pi-search" styleClass="p-button-warn"
                                    style="margin-left: 10px;"></button>
                            </div>
                        </span>
                    </div>

                    <div class="field text-left">
                        <label for="Department">{{DeptLabel}}</label>
                        <p-autoComplete [dropdown]="true" formControlName="departmentName" [forceSelection]="true"
                            [dropdown]="(products.length > 0)? false : true" [readonly]="products.length > 0"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.departmentName.errors }"
                            styleClass="w-full p-inputtext-sm" [suggestions]="filterDepartments"
                            (completeMethod)="filterDepartment($event)" (onSelect)="SelectedDepartment($event)"
                            field="departmentName" placeholder="Search {{DeptLabel}}" (keydown.enter)="focusNextInput($event)">
                            <ng-template let-item pTemplate="item">
                                <span>{{item.departmentCode}} - {{item.departmentName}}</span>
                            </ng-template>
                        </p-autoComplete>
                        <!-- Hidden department ID field for validation -->
                        <input type="hidden" formControlName="departmentId" />
                    </div>

                    <div class="field text-left">
                        <label for="challenNo">Challan Number</label>
                        <input pInputText formControlName="challenNo" class="w-full" [readonly]="products.length > 0"
                            (keydown.enter)="focusNextInput($event)" />
                    </div>

                    <div class="field text-left">
                        <label for="poNumber">PO Number</label>
                        <input pInputText formControlName="poNumber" class="w-full" [readonly]="products.length > 0"
                            (keydown.enter)="focusNextInput($event)" />
                    </div>

                </div>


                <div class="col">
                    <div class="field text-left">
                        <label for="returnDate" class="label-required display">Return Date</label>
                        <div class="p-inputgroup p-lookup">
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="returnDate"
                                [showIcon]="true" placeholder="Select Date"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.returnDate.errors }"
                                styleClass="w-full" (keydown.enter)="focusNextInput($event)"></p-calendar>
                        </div>
                    </div>

                    <div class="field text-left">
                        <label for="challanDate">Challan Date</label>
                        <div class="p-inputgroup p-lookup">
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="challanDate"
                                [showIcon]="true" placeholder="Select Date"
                                styleClass="w-full" (keydown.enter)="focusNextInput($event)"></p-calendar>
                        </div>
                    </div>


                    <div class="field text-left">
                        <label for="receiveDate">Received Date</label>
                        <div class="p-inputgroup p-lookup">
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="receiveDate"
                                [showIcon]="true" placeholder="Select Date"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.receiveDate.errors }"
                                styleClass="w-full" (keydown.enter)="focusNextInput($event)">
                            </p-calendar>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div>
        <form [formGroup]="purchaseOrderLineItemForm">
            <p-tabView [(activeIndex)]="activeIndex">
                <p-tabPanel header="Order Lines">
                    <p-table #dt1 [value]="products" responsiveLayout="scroll" class="w-full m-5"
                        styleClass="p-datatable-sm" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,15, 20]"
                        [paginator]="true" [(selection)]="selectedProduct">
                        <ng-template pTemplate="header">
                            <tr>
                                <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                                <th>Sr No</th>
                                <th pSortableColumn="ProductCode">Code <p-sortIcon field="ProductCode"></p-sortIcon>
                                </th>
                                <th>Product Name</th>
                                <th></th>
                                <th>UOM </th>
                                <th>Recd Qty</th>
                                <th>Rej Qty</th>
                                <th>Return Qty</th>
                                <th class="text-left">Cost(₹)</th>
                                <th class="text-left">Amount(₹)</th>
                                <th class="text-left">Disc(%)</th>
                                <th class="text-center">NetAmount(₹)</th>
                                <th>GST(%)</th>
                                <th class="text-right">GST(₹)</th>
                                <th class="text-right">LineAmount(₹)</th>
                                <th class="text-right">Remark</th>
                                <th class="text-right">Project</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product let-i="rowIndex">
                            <tr>
                                <td>
                                    <p-tableCheckbox [value]="product"></p-tableCheckbox>
                                </td>
                                <td>{{i+1}}</td>
                                <td class="text-blue-500 underline" style="cursor: pointer;" [pEditableColumn]="product"
                                    pEditableColumnField="ProductCode" (click)="viewProduct(product)">
                                    {{ product.ProductCode }}
                                </td>
                                <td>{{ product.ProductDescription }}</td>
                                <!-- <td [pEditableColumn]="product" pEditableColumnField="ProductDescription">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <input pInputText type="text" (blur)="onProductEdit(product)"
                                                    [(ngModel)]="product.ProductDescription"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    (keydown.enter)="focusNextInput($event)" />
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                <span *ngIf="product.ProductDescription.length > 20; else fullText">
                                                    {{ product.ProductDescription }}
                                                </span>
                                                <ng-template #fullText>
                                                    {{ product.ProductDescription }}
                                                </ng-template>
                                            </ng-template>
                                        </p-cellEditor>
                                    </td> -->
                                <td><span class="text-lg cursor-pointer" (click)="showSpecification(product)"><i
                                            class="pi pi-flag-fill"></i></span></td>
                                <td [pEditableColumn]="product" [pEditableColumnField]="'uom'">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <div class="p-inputgroup p-lookup">
                                                <input type="text" pInputText class="p-inputtext"
                                                    [(ngModel)]="product.Uom" [ngModelOptions]="{ standalone: true }"
                                                    [disabled]="true" />
                                                <button type="button" pButton pRipple icon="pi pi-search"
                                                    styleClass="p-button-warn"
                                                    (click)="showProductUom(product)"></button>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{product.Uom}}
                                        </ng-template>
                                    </p-cellEditor>

                                </td>
                                <td> {{ product.ReceivedQuantity }}</td>
                                <td> {{ product.RejectedQuantity }}</td>
                                <td class="text-left" [pEditableColumn]="product" pEditableColumnField="ReturnQuantity">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="number" min="0"
                                                (blur)="onReturnQuantityBlur(product)"
                                                (ngModelChange)="onReturnQtyChanged(product)"
                                                [(ngModel)]="product.ReturnQuantity"
                                                [ngModelOptions]="{ standalone: true }"
                                                (keydown)="onKeydown($event,product)" />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <span
                                                [ngClass]="{'text-red-500': product.ReturnQuantity > (product.RejectedQuantity > 0 ? product.RejectedQuantity : product.ReceivedQuantity)}">
                                                {{ product.ReturnQuantity }}
                                            </span>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td class="text-left" [pEditableColumn]="product" pEditableColumnField="Cost">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="number" min="1" (blur)="onProductEdit(product)"
                                                [(ngModel)]="product.Cost" [ngModelOptions]="{ standalone: true }"
                                                (keydown)="onKeydown($event,product)" />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ product.Cost.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                            maximumFractionDigits: 2}) }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td class="text-center">
                                    {{ (product.ExtendedCost || 0).toLocaleString('en-IN', { minimumFractionDigits: 2,
                                    maximumFractionDigits: 2 }) }}
                                </td>
                                <td class="text-left">{{ product.Discount }}</td>
                                <td class="text-center">
                                    {{ (product.NetAmount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2,
                                    maximumFractionDigits: 2 }) }}
                                </td>
                                <td>{{ product.GSTRate }}</td>
                                <td class="text-right">
                                    {{ ((product.CGST || 0) + (product.SGST || 0) + (product.IGST || 0)).toLocaleString('en-IN', {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                </td>
                                <td class="text-right">
                                    {{ (product.LineTotal || 0).toLocaleString('en-IN', { minimumFractionDigits: 2,
                                    maximumFractionDigits: 2 }) }}
                                </td>
                                <td class="text-right"><span class="text-lg cursor-pointer" (click)="showComment(product)"><i
                                            class="pi pi-comment"></i></span></td>
                                <td>{{ product.projectBoMName }}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="grid" [formGroup]="purchaseOrderForm">
                                <div class="col-5 md:col-8">
                                    <div class="grid formgrid w-full">
                                        <div class="field col-12 md:col-4">
                                            <label>Freight Charges(₹)</label>
                                            <input type="text" pInputText class="w-full" formControlName="FreightAmount"
                                                (input)="recalcChargeFooter(true)" />
                                        </div>
                                        <div class="field col-12 md:col-4">
                                            <label for="GSTRateOnFreight" class="font-semibold mb-1 block">Rate on Freight</label>
                                            <p-dropdown id="GSTRateOnFreight" class="w-full" [options]="gstOptions"
                                                optionLabel="label" optionValue="value" placeholder="Select GST"
                                                formControlName="GSTRateOnFreight"
                                                (onChange)="recalcChargeFooter(true)">
                                            </p-dropdown>
                                        </div>
                                        <div class="field col-12 md:col-4">
                                            <label>GST on Freight(₹)</label>
                                            <input type="text" pInputText class="w-full" formControlName="GSTOnFreight"
                                                readonly />
                                        </div>
                                        <div class="field col-12 md:col-4">
                                            <label>P&amp;F Charges(₹)</label>
                                            <input type="text" pInputText class="w-full" formControlName="PackingForwarding"
                                                (input)="recalcChargeFooter(true)" />
                                        </div>
                                        <div class="field col-12 md:col-4">
                                            <label for="GSTRateOnPNF" class="font-semibold mb-1 block">Rate on P&amp;F</label>
                                            <p-dropdown id="GSTRateOnPNF" class="w-full" [options]="gstOptions"
                                                optionLabel="label" optionValue="value" placeholder="Select GST"
                                                formControlName="GSTRateOnPNF"
                                                (onChange)="recalcChargeFooter(true)">
                                            </p-dropdown>
                                        </div>
                                        <div class="field col-12 md:col-4">
                                            <label>GST on P&amp;F(₹)</label>
                                            <input type="text" pInputText class="w-full" formControlName="GSTOnPNFAmount"
                                                readonly />
                                        </div>
                                    </div>
                                </div>
                                <div class="col flex flex-column align-items-end">
                                    <div class="field text-left">
                                        CGST : ₹ {{CGSTtotal.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                        maximumFractionDigits: 2})}}
                                    </div>
                                    <div class="field text-left">
                                        SGST : ₹ {{SGSTtotal.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                        maximumFractionDigits: 2})}}
                                    </div>
                                    <div class="field text-left">
                                        IGST : ₹ {{IGSTtotal.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                        maximumFractionDigits: 2})}}
                                    </div>
                                    <div class="field text-left">
                                        Taxable : ₹ {{lineTaxableTotal.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                        maximumFractionDigits: 2})}}
                                    </div>
                                    <div class="field text-left">
                                        Final Taxable Amount : ₹ {{FinalTaxableAmt.toLocaleString('en-IN', {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2})}}
                                    </div>
                                    <div class="field text-left">
                                        <div class="hr-line"></div><br>
                                        <div style="display: flex; align-items: center;">
                                            <div style="margin-right: 20px;">
                                                Total Qty : <span>{{ weightTotal.toLocaleString('en-IN', {
                                                    minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
                                            </div>
                                            <div style="margin: 0 20px;">|</div>
                                            <div>Total: ₹ <span>{{orderTotal.toLocaleString('en-IN', {
                                                    minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>

                    </p-table>
                </p-tabPanel>

                <p-tabPanel header="PO Details">

                    <form [formGroup]="purchaseOrderForm">

                        <div class="grid">

                            <div class="col">

                                <div class="field text-left">
                                    <label for="Taxes">Taxes</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText class="w-full p-inputtext-sm" formControlName="Taxes"
                                            (keydown.enter)="focusNextInput($event)" />
                                    </div>
                                </div>

                                <!-- <div class="field text-left">
                                        <label for="projectName">Project Name</label>
                                        <div style="display: flex; align-items: center;">
                                                <input pInputText class="w-full p-inputtext-sm" formControlName="projectName" readonly
                                                (keydown.enter)="focusNextInput($event)" />
                                                <div style="margin-left: 10px;">
                                                <p-button  icon="pi pi-search" (click)="getProduct()" [raised]="true" [size]="'small'"
                                        severity="info"></p-button>
                                            </div>
                                        </div>
                                    </div> -->


                                <div class="field text-left">
                                    <label for="Delivery">Delivery</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText class="w-full p-inputtext-sm" formControlName="Delivery"
                                            (keydown.enter)="focusNextInput($event)" />
                                    </div>
                                </div>

                                <div class="field text-left">
                                    <label for="termsCode">Special Instruction</label>
                                    <div class="p-inputgroup p-lookup">
                                        <textarea rows="5" cols="30" pInputTextarea
                                            formControlName="specialInstruction">
                                                </textarea>
                                    </div>
                                </div>

                            </div>

                            <div class="col">

                                <!-- <div class="field text-left">
                                        <label for="Transport">Transport</label>
                                        <div class="p-inputgroup p-lookup">
                                            <input pInputText class="w-full p-inputtext-sm" formControlName="Transport"
                                                (keydown.enter)="focusNextInput($event)" />
                                        </div>
                                    </div> -->

                                <div class="field text-left">
                                    <label for="termsCode">Payment Terms</label>
                                    <div class="p-inputgroup p-lookup">
                                        <input pInputText class="w-full p-inputtext-sm" formControlName="termsCode"
                                            readonly (keydown.enter)="focusNextInput($event)" />
                                        <button type="button" pButton pRipple severity="info" icon="pi pi-search"
                                            (click)="getTermsCode()"></button>
                                    </div>
                                </div>

                                <!-- <div class="field text-left">
                                        <label for="Validity">Validity</label>
                                        <div class="p-inputgroup p-lookup">
                                            <input pInputText class="w-full p-inputtext-sm" formControlName="Validity"
                                                (keydown.enter)="focusNextInput($event)" />
                                        </div>
                                    </div> -->


                                <div class="field text-left">
                                    <label for="PurchaseOrderComment">Purchase Order Comment</label>
                                    <div class="p-inputgroup p-lookup">
                                        <textarea rows="5" cols="30" pInputTextarea
                                            formControlName="purchaseOrderComment">
                                                </textarea>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </form>

                </p-tabPanel>

                <p-tabPanel header="GL Posting Details" *ngIf="isGlPosted">
                    <div class="gl-posting-section gl-posting-in-tab mt-3">
                        <p-table *ngIf="glEntries.length > 0" [value]="glEntries"
                            [tableStyle]="{'min-width': '60rem'}"
                            styleClass="p-datatable-sm p-datatable-gridlines">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>GL Account</th>
                                    <th>Account Name</th>
                                    <th class="text-right">Debit (₹)</th>
                                    <th class="text-right">Credit (₹)</th>
                                    <th>Warehouse</th>
                                    <th>Department</th>
                                    <th>Posted Date</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-entry>
                                <tr>
                                    <td>{{ entry.accountCode }}</td>
                                    <td>{{ entry.accountName }}</td>
                                    <td class="text-right">{{ formatGlAmount(entry.debitAmount) }}</td>
                                    <td class="text-right">{{ formatGlAmount(entry.creditAmount) }}</td>
                                    <td>{{ entry.warehouseName }}</td>
                                    <td>{{ entry.departmentName }}</td>
                                    <td>{{ entry.postedDate | date:'dd/MM/yyyy' }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <tr>
                                    <td colspan="2" class="text-right font-bold">Total</td>
                                    <td class="text-right font-bold">{{ formatGlAmount(glTotalDebit) }}</td>
                                    <td class="text-right font-bold">{{ formatGlAmount(glTotalCredit) }}</td>
                                    <td colspan="3"></td>
                                </tr>
                            </ng-template>
                        </p-table>
                        <p *ngIf="glEntries.length === 0" class="text-color-secondary m-0">
                            GL is posted. Refresh the page to load entry details.
                        </p>
                    </div>
                </p-tabPanel>

            </p-tabView>


        </form>
    </div>

</p-card>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>